import { render, staticRenderFns } from "./TablaUsuario.vue?vue&type=template&id=99c83e4e&scoped=true&"
import script from "./TablaUsuario.vue?vue&type=script&lang=js&"
export * from "./TablaUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TablaUsuario.vue?vue&type=style&index=0&id=99c83e4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c83e4e",
  null
  
)

export default component.exports